import { DataLayerManagerInterface } from 'Common/ga/dataLayerManager/abstractDataLayerManager';

const CLICK_CTA_EVENT = 'event-bellaCartCtaButtonClicked';
const REMOVE_PRODUCT_EVENT = 'event-bellaCartRemoveProduct';
const ADD_PRODUCT_TO_WISHLIST_EVENT = 'event-bellaCartAddProductToWishlist';
const CHANGE_PRODUCT_QUANTITY_EVENT = 'event-bellaCartChangeProductQuantity';
const REMOVE_PRODUCT_BY_ZERO_QUANTITY_EVENT = 'event-bellaCartRemoveProductByZeroQuantity';
const EXPAND_VOUCHER_FIELD_EVENT = 'event-bellaCartExpandVoucherField';
const SUBMIT_VOUCHER_EVENT = 'event-bellaCartSubmitVoucher';
const EXPAND_COST_DETAIL_EVENT = 'event-bellaCartExpandCostDetail';
const ERROR_MESSAGE_SHOWN_EVENT = 'event-bellaCartErrorMessageShown';

export default class CartTracker {
    private readonly dataLayerManager: DataLayerManagerInterface;

    public constructor(dataLayerManager: DataLayerManagerInterface) {
        this.dataLayerManager = dataLayerManager;
    }

    public trackClickCTAButton() {
        this.dataLayerManager.sendEvent(CLICK_CTA_EVENT, {});
    }

    public trackRemoveProductFromCart(sku: string) {
        this.dataLayerManager.sendEvent(REMOVE_PRODUCT_EVENT, { sku });
    }

    public trackAddProductToWishlist(sku: string) {
        this.dataLayerManager.sendEvent(ADD_PRODUCT_TO_WISHLIST_EVENT, { sku });
    }

    public trackChangeProductQuantity(sku: string) {
        this.dataLayerManager.sendEvent(CHANGE_PRODUCT_QUANTITY_EVENT, { sku });
    }

    public trackRemoveByZeroQuantity(sku: string) {
        this.dataLayerManager.sendEvent(REMOVE_PRODUCT_BY_ZERO_QUANTITY_EVENT, { sku });
    }

    public trackExpandVoucherField() {
        this.dataLayerManager.sendEvent(EXPAND_VOUCHER_FIELD_EVENT, {});
    }

    public trackSubmitVoucher() {
        this.dataLayerManager.sendEvent(SUBMIT_VOUCHER_EVENT, {});
    }

    public trackExpandCostDetail() {
        this.dataLayerManager.sendEvent(EXPAND_COST_DETAIL_EVENT, {});
    }

    public trackErrorMessageShown(errorMessage: string) {
        this.dataLayerManager.sendEvent(ERROR_MESSAGE_SHOWN_EVENT, { errorMessage });
    }
}
